import { type MailProtocolEntryDto, MailProtocolStatus } from './MailProtocol.model'
import {
	convertUnixToLocale,
	convertUnixToUtcEnd,
	convertUnixToUtcStart,
	type UnixDateRange
} from '../types/datepicker'
import { replaceUrl } from '../utils/misc'
import dayjs from 'dayjs'
import { fetchUtils } from '../utils/fetchUtils'

export async function fetchMailProtocol(
	search: string,
	timeframe: UnixDateRange,
	status: MailProtocolStatus | null
): Promise<MailProtocolEntryDto[]> {
	const startDate = convertUnixToUtcStart(Math.min(...timeframe)).unix()
	const endDate = convertUnixToUtcEnd(Math.max(...timeframe)).unix()
	const payload = { search, timeframe: { start: startDate, end: endDate }, status }
	const url = '/api/mailProtocol'
	return fetchUtils.post(url, payload)
}

export function updateUrlWithSearchParams(
	search: string | null,
	timeframe: UnixDateRange,
	status: MailProtocolStatus | null,
	window: Window
) {
	const searchParams = new URLSearchParams(window.location.search)
	// conversion of unix to utc timezone unix
	const start = convertUnixToUtcStart(timeframe[0]).unix()
	const end = convertUnixToUtcEnd(timeframe[1]).unix()

	if (timeframe) {
		searchParams.set('startDate', start.toString())
		searchParams.set('endDate', end.toString())
	} else {
		searchParams.delete('startDate')
		searchParams.delete('endDate')
	}
	if (status !== null && status !== undefined) {
		searchParams.set('state', status.toString())
	} else {
		searchParams.delete('success')
	}
	if (search) {
		searchParams.set('search', search)
	} else {
		searchParams.delete('search')
	}
	replaceUrl('/mailProtocol', window, searchParams)
}

export function getParamsFromUrlOrDefault(urlParams: URLSearchParams): {
	timeframe: UnixDateRange
	searchTerm: string | null
	status: MailProtocolStatus | null
} {
	const startDate = dayjs().utc().startOf('month').unix()
	const endDate = dayjs().utc().endOf('day').unix()

	// check, if the params exist, is not 0 and not 'NaN'
	const startDateParam =
		urlParams.get('startDate') && !isNaN(Number(urlParams.get('startDate')))
			? Number(urlParams.get('startDate'))
			: null
	const endDateParam =
		urlParams.get('endDate') && !isNaN(Number(urlParams.get('endDate')))
			? Number(urlParams.get('endDate'))
			: null
	return {
		timeframe: [
			// we must convert to the locale time such that the date picker works correctly,
			// since the timestamps in the url are utc unix timestamps
			startDateParam
				? convertUnixToLocale(startDateParam).unix()
				: convertUnixToLocale(startDate).unix(),
			endDateParam ? convertUnixToLocale(endDateParam).unix() : convertUnixToLocale(endDate).unix()
		],
		searchTerm: urlParams.get('search')?.length > 0 ? urlParams.get('search') : '',
		status:
			urlParams.get('status')?.length > 0 ? (urlParams.get('status') as MailProtocolStatus) : null
	}
}
